import { encryptPartnerId, decryptPartnerId, isEncrypted } from "@/utils/encryption/partnerId";

const STORAGE_KEY = "encrypted_partner_id";

export function setPartnerIdToStorage(partnerId: string): void {
  if (!partnerId) {
    localStorage.removeItem(STORAGE_KEY);
    return;
  }

  try {
    const encrypted = encryptPartnerId(partnerId);
    localStorage.setItem(STORAGE_KEY, encrypted);
  } catch (error) {
    console.error("Error saving partner_id to storage:", error);
  }
}

export function getPartnerIdFromStorage(): string | null {
  try {
    const encrypted = localStorage.getItem(STORAGE_KEY);
    
    if (!encrypted) {
      return null;
    }

    if (isEncrypted(encrypted)) {
      return decryptPartnerId(encrypted);
    }
    
    return encrypted;
  } catch (error) {
    console.error("Error getting partner_id from storage:", error);
    return null;
  }
}

export function removePartnerIdFromStorage(): void {
  localStorage.removeItem(STORAGE_KEY);
}
